import { forwardRef } from 'react';
import { IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

interface NotificationTriggerProps {
  openNotification: () => void;
  unreadCount: number;
}

const NotificationTrigger = forwardRef<HTMLButtonElement, NotificationTriggerProps>(
  (props, ref) => {
    return (
      <IconButton
        ref={ref}
        color="inherit"
        aria-label="notifications"
        onClick={props.openNotification}
        sx={{ position: 'relative' }}
      >
        <Badge badgeContent={props.unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
    );
  }
);

NotificationTrigger.displayName = 'NotificationTrigger';

export default NotificationTrigger;
